const
    configurations = {
        baseUrl: process.env.REACT_APP_BASE_URL,
        enrollmentURL : process.env.REACT_APP_ENROLLMENT_URL,
        enrollmentBaseURL : process.env.REACT_APP_enrollment_base_url,
        AGENT_BASE_URL : process.env.REACT_APP_AGENT_URL,
        RADIO_PORTAL_URL : process.env.REACT_APP_RADIO_PORTAL_URL,
        BRAND : process.env.REACT_APP_BRAND
    }

export default configurations;